// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/components/profilecard/loader/index.scss
// module id = 3020
// module chunks = 13